import { ChartOptions } from 'chart.js'
import { truncateChartLabel } from './misc'
import {
    MultiBarGraphInsightViewProps,
    SingleBarGraphInsightViewProps,
} from '../../components'

export const BAR_GRAPH_MAX_LABEL_LENGTH = 10
export const DEFAULT_BAR_GRAPH_BAR_WIDTH = 30
export const SCROLL_BAR_THICKNESS = 12
export const AXIS_TITLE_THICKNESS = 45

export const getLargestBarGraphDimension = (labels?: string[]) => {
    if (!labels || labels.length === 0) return 0

    return DEFAULT_BAR_GRAPH_BAR_WIDTH * labels.length + AXIS_TITLE_THICKNESS
}

export const getBarGraphConfig = (
    props: SingleBarGraphInsightViewProps | MultiBarGraphInsightViewProps,
    type: 'scrollable' | 'axis'
): ChartOptions<'bar'> => {
    const horizontalScroll = props.orientation === 'vertical'
    const verticalScroll = props.orientation === 'horizontal'
    const isScrollable = type === 'scrollable'
    const isAxis = type === 'axis'

    return {
        aspectRatio: 1,
        resizeDelay: 50,
        maintainAspectRatio: false,
        indexAxis: horizontalScroll ? 'x' : 'y',
        plugins: {
            legend: {
                display: 'groups' in props && !isAxis,
            },
        },
        ...(isScrollable && {
            layout: {
                padding: {
                    bottom: verticalScroll ? -45 : 0,
                    left: horizontalScroll ? -45 : 0,
                },
            },
        }),
        scales: {
            x: {
                border: { display: false },
                stacked: 'groups' in props && props.stacked,
                title: {
                    display: true,
                    color: isScrollable ? 'transparent' : undefined,
                    text: props.axes.x,
                },
                ticks: {
                    color:
                        (isScrollable && verticalScroll) ||
                        (isAxis && horizontalScroll)
                            ? 'transparent'
                            : undefined,
                    precision: props.floatPrecision ? undefined : 0,
                },
                ...(isAxis && {
                    grid: {
                        drawOnChartArea: false,
                        tickColor: 'transparent',
                    },
                }),
            },
            y: {
                border: { display: false },
                stacked: 'groups' in props && props.stacked,
                title: {
                    display: true,
                    color: isScrollable ? 'transparent' : undefined,
                    text: props.axes.y,
                },
                ticks: {
                    color:
                        (isScrollable && horizontalScroll) ||
                        (isAxis && verticalScroll)
                            ? 'transparent'
                            : undefined,
                    precision: props.floatPrecision ? undefined : 0,
                    callback: function (value) {
                        return truncateChartLabel(
                            value as number,
                            BAR_GRAPH_MAX_LABEL_LENGTH,
                            this.getLabelForValue.bind(this)
                        )
                    },
                },
                ...(isAxis && {
                    grid: {
                        drawOnChartArea: false,
                        tickColor: 'transparent',
                    },
                }),
                beginAtZero: true,
            },
        },
    }
}
